import facebook_logo from "../../assets/logos/facebook_logo.png";
import instagram_logo from "../../assets/logos/instagram_logo.png";
import twitter_logo from "../../assets/logos/twitter_logo.png";
import linkedin_logo from "../../assets/logos/linkedin_logo.png";
import youtube_logo from "../../assets/logos/youtube_logo.png";

// list of logos that are shown on the footer
export const SocialMediaItems = [
  {
    title: "facebook",
    url: "https://pt-pt.facebook.com/phosphorland",
    icon: facebook_logo,
  },
  {
    title: "instagram",
    url: "https://instagram.com/phosphorland",
    icon: instagram_logo,
  },
  {
    title: "linkedin",
    url: "https://linkedin.com/company/phosphorland",
    icon: linkedin_logo,
  },
  {
    title: "twitter",
    url: "https://twitter.com/phosphorland",
    icon: twitter_logo,
  },
  {
    title: "youtube",
    url: "https://youtube.com/channel/UCgThjMgx2UFaHdFcZY2uc1g",
    icon: youtube_logo,
  },
];
